import React from "react";
import {
    UserOutlined,
    CheckCircleOutlined,
    MailOutlined,
    CloseCircleOutlined,
    SaveOutlined,
} from "@ant-design/icons";
import StatsCard from "../../../components/StatsCard";
import { Col, Row } from "antd";


const OrganizationAnalysis = () => {

    const stats = [
        {
            label: "Total Head Count",
            value: 32,
            icon: <UserOutlined />,
            color: "#FFA500",
            extraInfo: "+4 / -0",
        },
        {
            label: "Registered",
            value: 31,
            icon: <CheckCircleOutlined />,
            color: "#6A5ACD",
        },
        {
            label: "Not Invited",
            value: 0,
            icon: <MailOutlined />,
            color: "#32CD32",
        },
        {
            label: "Yet to Register",
            value: 0,
            icon: <CloseCircleOutlined />,
            color: "#FF6347",
        },
    ];

    const PendingStats = [
        {
            label: "Doccuments",
            value: 32,
            icon: <SaveOutlined />,
            color: "#FFA500",
        },
        {
            label: "Expenses",
            value: 31,
            icon: <CheckCircleOutlined />,
            color: "#6A5ACD",
        },
        {
            label: "Probations",
            value: 0,
            icon: <MailOutlined />,
            color: "#32CD32",
        },
        {
            label: "Join Tasks",
            value: 0,
            icon: <CloseCircleOutlined />,
            color: "#FF6347",
        },
        {
            label: "Exit Tasks",
            value: 0,
            icon: <CloseCircleOutlined />,
            color: "#FF6347",
        },
        {
            label: "Profile Changes",
            value: 0,
            icon: <CloseCircleOutlined />,
            color: "#FF6347",
        },
    ];

    return (
        <Row gutter={[16, 16]}>
            <Col span={8}>
                <StatsCard title="Employees" stats={stats} />
            </Col>
            <Col flex={"auto"}>
                <StatsCard title="Pending Actions" span={8} stats={PendingStats} />
            </Col>
        </Row>
    );
}

export default OrganizationAnalysis;